import { useInView } from './hooks/useInView';

const ISSUES = [
  'Banking is centralized and siloed',
  'Crypto is complex and fragmented',
  'Identity is repeatedly verified everywhere',
  'DeFi is disconnected from real-world finance',
  'Communities are separated from financial participation',
];

const SOLUTIONS = [
  'Self-custodial asset control — full sovereignty',
  'Fiat connectivity via licensed partners',
  'Nomo-ID protocol — one verification, reused everywhere',
  'Web3-native infrastructure bridging DeFi and the real world',
  'Cooperative governance — participation at scale',
];

export default function Welcome() {
  const [ref, inView] = useInView();

  return (
    <section className="welcome section" id="welcome" ref={ref}>
      <div className="container welcome__inner">
        <div className={`reveal-left ${inView ? 'in-view' : ''}`}>
          <div className="welcome__label">Welcome to NOMO</div>

          <h2 className="welcome__title">
            <span style={{ color: 'var(--white)' }}>Your gateway to the</span>{' '}
            <span className="gradient-text">decentralized era.</span>
          </h2>

          <div className="welcome__manifesto">
            <p className="welcome__statement">
              NOMO is the next-generation Web3 platform engineered to unify
              DeFi, digital identity, and real-world fiat connectivity —
              inside one seamless ecosystem.
            </p>
            <p className="welcome__statement welcome__statement--em">
              It is not another wallet.
            </p>
            <p className="welcome__statement welcome__statement--em">
              It is not another exchange.
            </p>
            <p className="welcome__statement">
              It is DeFi, sovereign identity, and Web3 infrastructure —
              built from the ground up for the next era.
            </p>
          </div>
        </div>

        <div className={`welcome__right reveal-right ${inView ? 'in-view' : ''}`}>
          <div className="welcome__glass-card">
            <div className="welcome__big-text" aria-hidden="true">WEB3</div>
            <div className="welcome__feature-panel">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
                <div>
                  <div className="welcome__feature-panel-label" style={{ color: 'var(--white-dim)' }}>Today</div>
                  {ISSUES.map((issue) => (
                    <div
                      key={issue}
                      className="welcome__descriptor-item"
                      style={{ borderBottom: '1px solid rgba(255,255,255,0.04)', padding: '7px 0' }}
                    >
                      <span style={{ color: 'rgba(255,255,255,0.2)', flexShrink: 0 }}>—</span>
                      <span className="welcome__descriptor-left" style={{ fontSize: '0.7rem' }}>{issue}</span>
                    </div>
                  ))}
                </div>
                <div>
                  <div className="welcome__feature-panel-label">NOMO</div>
                  {SOLUTIONS.map((sol) => (
                    <div
                      key={sol}
                      className="welcome__descriptor-item"
                      style={{ borderBottom: '1px solid rgba(255,255,255,0.04)', padding: '7px 0' }}
                    >
                      <span style={{ color: 'var(--gold)', fontSize: '0.55rem', flexShrink: 0 }}>◆</span>
                      <span className="welcome__descriptor-left" style={{ fontSize: '0.7rem', color: 'var(--white-muted)' }}>{sol}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
